import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, CircleCheck, ImageIcon } from "lucide-react";
import api, { buildDownloadUrl } from "@/lib/api";

export const Thumb = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  if (failed) return <ImageIcon className="w-5 h-5 text-[#52525B]" data-testid="thumb-fallback" />;
  return (
    <>
      {!loaded && <span className="absolute inset-2 bg-black/5 animate-pulse" />}
      <img src={src} alt={alt} loading="lazy" onLoad={() => setLoaded(true)} onError={() => setFailed(true)}
        className={`max-h-full max-w-full object-contain transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`} />
    </>
  );
};

export const RecentLogos = ({ activeId, onOpen, refreshKey }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/jobs").then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, [refreshKey]);

  if (!items?.length) return null;
  return (
    <div className="mb-10" data-testid="recent-logos">
      <div className="flex items-center justify-between mb-3">
        <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#52525B]">Your logos</div>
        <Link to="/history" className="text-xs uppercase tracking-[0.2em] font-bold text-[#ED5A24] hover:underline" data-testid="recent-logos-all">View all</Link>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2">
        {items.slice(0, 10).map((j) => (
          <button key={j.job_id} type="button" onClick={() => onOpen(j.job_id)} data-testid={`recent-logo-${j.job_id}`} title={j.name}
            className={`group shrink-0 w-28 text-left border transition-colors duration-200 ${activeId === j.job_id ? "border-[#ED5A24]" : "border-black/10 hover:border-[#0A0A0B]"}`}>
            <div className="relative h-24 bg-[#F8F9FA] flex items-center justify-center p-2">
              <Thumb src={buildDownloadUrl(j.thumb)} alt={j.name} />
              <span className={`absolute top-1 right-1 w-5 h-5 flex items-center justify-center ${j.unlocked ? "bg-[#16A34A]" : "bg-[#0A0A0B]"} text-white`}
                data-testid={`recent-logo-${j.unlocked ? "unlocked" : "locked"}-${j.job_id}`}>
                {j.unlocked ? <CircleCheck className="w-3 h-3" /> : <Lock className="w-3 h-3" />}
              </span>
            </div>
            <div className="px-2 py-1.5 text-[11px] font-medium truncate">{j.name}</div>
          </button>
        ))}
      </div>
    </div>
  );
};
